import styled from 'styled-components'
import { getFontStyle, colors } from '@diversioteam/diversio-ds'

import { SheetContent } from '@/components/ui/Sheet'

// Ghost button styled component to replace Button variant="ghost"
export const MenuButton = styled.button`
    padding: 0.5rem;
    height: 2.25rem;
    width: 2.25rem;
    background-color: transparent;
    color: var(--foreground);
    border: 1px solid transparent;
    border-radius: 0.375rem;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover:not(:disabled) {
        background-color: var(--accent);
        color: var(--accent-foreground);
    }

    &:disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    &:focus-visible {
        outline: 2px solid var(--ring);
        outline-offset: 2px;
    }

    @media (min-width: 768px) {
        display: none;
    }
`

export const CloseButton = styled.button`
    padding: 0.25rem;
    height: 2rem;
    width: 2rem;
    color: #e5e7eb;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 0.375rem;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover:not(:disabled) {
        background-color: #374151;
    }

    &:disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    &:focus-visible {
        outline: 2px solid var(--ring);
        outline-offset: 2px;
    }
`

export const NavHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    border-bottom: 1px solid #374151;
`

export const NavTitle = styled.h2`
    ${getFontStyle('h3Bold')} /* 20px, 700 weight - matches font-semibold */
    color: #e5e7eb;
`

export const NavContent = styled.div`
    flex: 1;
    overflow-y: visible;
`

export const ScreenReaderText = styled.div`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
`

export const StyledSheetContent = styled(SheetContent)`
    padding: 0;
    width: 256px;
    background-color: ${colors.primary60};
    border-color: ${colors.primary50};
    border-width: 1px;
`
